module.exports = new __parcel__URL__("crystalmage.1d4d3e31.png").toString();